import { Popup, Icon, List } from "semantic-ui-react";
import { CheckIcon, WarningIcon } from "../index";

const styles = {
	errorPopup: {},
};
const endoErrorsExplicit = {
	cleanHands: "S'être lavé les mains avant le prélèvement",
	noInfectionSigns: "Ne pas avoir de signes d'infection (fièvre, toux, rhume, etc.)",
	noVIH: "Ne pas être infecté à VIH",
	noPregnant: "Ne pas avoir de grossesse en cours",
	noCancer: "Ne pas avoir d'antécédents de cancer",
	noEating: "Ne pas avoir mangé 30 minutes avant le prélèvement",
	noDrinking: "Ne pas avoir bu 30 minutes avant le prélèvement",
	noSmoking: "Ne pas avoir fumé 30 minutes avant le prélèvement",
	noChewingGum: "Ne pas avoir mâché de chewing-gum 30 minutes avant le prélèvement",
	noTeethBrushing: "Ne pas s'être brossé les dents 30 minutes avant le prélèvement",
	noLipStick: "Ne pas avoir porté de rouge à lèvres 30 minutes avant le prélèvement",
	conform: "Echantillon conforme",
};

const EndotestTab = ({ t, disabled, endoErrors, endoStatus }) => {
	return (
		<Popup
			position="bottom right"
			disabled={!endoErrors || endoStatus || disabled}
			style={styles.errorPopup}
			offset="7px, 0"
			trigger={
				<span>
					<Icon name="lab" size="small" /> {t("subMenu.endotest")}
					{!disabled && (endoStatus ? <CheckIcon /> : <WarningIcon />)}
				</span>
			}
		>
			<Popup.Header>{t("subMenu.endotestConditions")}</Popup.Header>
			<Popup.Content>
				<List bulleted>
					{endoErrors.map((error, index) => (
						<List.Item key={`endoErrors-${index}`}>{endoErrorsExplicit[error]}</List.Item>
					))}
				</List>
			</Popup.Content>
		</Popup>
	);
};

export default EndotestTab;
